import React from "react";
import I18n from "../../i18n/I18n";
import styles from "./VatNotification.scss";

const VatNotification = (props: Object) => {
  const { children } = props;
  return (
    <div className={styles.wrapper}>
      <div className={styles.notification}>{children}</div>
    </div>
  );
};

export default VatNotification;



// WEBPACK FOOTER //
// ./src/components/vatNotification/VatNotification.js